import cx from 'classnames'
import JSON_HEADERS from 'jsonHeaders'
import camelize from 'lib/camelize'
import { birmanize, joinWithComma } from 'lib/textHelper'
import DoubleHover from '../../assets/scripts/doubleHover'
import { TextNode } from '../textNodes'
import VacanciesSpacer, {
  LONG_TITLE_LENGTH,
  MEDIUM_TITLE_LENGTH,
  SMALL_TITLE_LENGTH,
  VacancyPlaceholder,
} from '../vacanciesSpacer/vacanciesSpacer'

const VacancyTitle = (props) => {
  return (
    <div className="vacanciesBanner-title">
      <TextNode>
        <a href={props.path} className="doubleHover is__noUnderline novisited">
          <b>Работа: </b>
          {props.children}
        </a>
      </TextNode>
    </div>
  )
}

const VacancyInfo = ({ endsAt, jobFormat, jobLocation }) => {
  const jobFormats = { remote: 'Удалёнка', office: 'В офис' }

  jobFormat = jobFormats[jobFormat] || ''
  jobLocation = jobLocation || ''
  endsAt = birmanize(endsAt, { format: 'tillCommaSeparatedDateAndWeekDayLowerCase' })

  return (
    <div className="vacanciesBanner-info-wrapper">
      <div className="vacanciesBanner-info">
        {`${joinWithComma([jobFormat, jobLocation])}`}
        <br />
        {`🕑 ${endsAt}`}
      </div>
    </div>
  )
}

class VacanciesBanner extends VacanciesSpacer {
  constructor(props) {
    super(props)

    this.state = { vacancies: props.vacancies || [] }
    this.buttonText = 'Откликнуться'
  }

  fetchVacancies() {
    fetch('/api/burosfera/vacancies/', { headers: JSON_HEADERS })
      .then(res => res.json())
      .then(json => this.setState({ vacancies: this.decorateVacancies(json) }))
      .catch(e => console.error(e))
  }

  decorateVacancies(vacancies) {
    return vacancies.map(camelize)
  }

  componentDidMount() {
    $(this.bannerRef).find('.doubleHover').each(function() { new DoubleHover($(this)) })

    if (!this.state.vacancies.length) this.fetchVacancies()
  }

  render(props) {
    if (!this.state.vacancies.length) return <VacancyPlaceholder {...props} />

    const isHalf = props.size === 'half'
    const isFull = props.size === 'full'

    const rndIndex = Math.floor(Math.random() * this.state.vacancies.length)
    const vacancy = this.state.vacancies[rndIndex]

    const isShortTitle = vacancy.jobTitle.length + vacancy.companyTitle.length <= SMALL_TITLE_LENGTH
    const isMediumTitle =
      vacancy.jobTitle.length + vacancy.companyTitle.length > SMALL_TITLE_LENGTH &&
      vacancy.jobTitle.length + vacancy.companyTitle.length <= MEDIUM_TITLE_LENGTH
    const isLongTitle = vacancy.jobTitle.length + vacancy.companyTitle.length > MEDIUM_TITLE_LENGTH

    const lowercasedTitle = `${vacancy.jobTitle[0].toLowerCase()}${vacancy.jobTitle.slice(1)}`

    const lowercasedTitleWithCompanyName = joinWithComma([lowercasedTitle, vacancy.companyTitle])

    const classes = cx(
      'vacanciesBanner',
      {
        is__shortTitle: isShortTitle,
        is__mediumTitle: isMediumTitle,
        is__longTitle: isLongTitle,
        is__half: isHalf,
        is__full: isFull,
      }
    )

    return (
      <div className={classes} ref={(el) => this.bannerRef = el}>
        <div className="device laptop desktop">
          {isFull &&
            <VacancyTitle path={vacancy.path}>
              {lowercasedTitleWithCompanyName}
            </VacancyTitle>
          }

          {isHalf &&
            <VacancyTitle path={vacancy.path}>
              {lowercasedTitleWithCompanyName}
              {lowercasedTitleWithCompanyName.length < LONG_TITLE_LENGTH &&
                <br />
              }
            </VacancyTitle>
          }
        </div>

        <div className="device mobile">
          <VacancyTitle path={vacancy.path}>
            {lowercasedTitleWithCompanyName}
            {(isShortTitle || isMediumTitle) &&
              <br />
            }
          </VacancyTitle>
        </div>

        <div className="vacanciesBanner-footer">
          <div className="vacanciesBanner-buttonWrapper">
            <a
              href={vacancy.path}
              className="button vacanciesBanner-button is__thin doubleHover">
              {this.buttonText}
            </a>
          </div>

          <VacancyInfo
            endsAt={vacancy.endsAt}
            jobFormat={vacancy.jobFormat}
            jobLocation={vacancy.jobLocation}
          />
        </div>
      </div>
    )
  }
}

export default VacanciesBanner
